export default __webpack_public_path__ + "static/media/evz-logo.b9383abc.png";